import { render, staticRenderFns } from "./AddModule.vue?vue&type=template&id=6f324352&scoped=true&"
import script from "./AddModule.vue?vue&type=script&lang=ts&"
export * from "./AddModule.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f324352",
  null
  
)

export default component.exports